"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutlinedIcon = exports.RegularIcon = void 0;
var RegularIcon_1 = require("./RegularIcon");
Object.defineProperty(exports, "RegularIcon", { enumerable: true, get: function () { return RegularIcon_1.RegularIcon; } });
var OutlinedIcon_1 = require("./OutlinedIcon");
Object.defineProperty(exports, "OutlinedIcon", { enumerable: true, get: function () { return OutlinedIcon_1.OutlinedIcon; } });
